import { useContext } from 'react';
import { TreeContext, TreeContextProps } from '../context/TreeContext';

const useTreeArea = (): TreeContextProps => useContext(TreeContext);

export default useTreeArea;
